import { ListVideoResultsYoutube, YoutubeVideo } from '@lib/domain/youtube';
import { APP_CONFIG } from '@lib/constants';
import Payment from 'payment';
import { ActionTypes, ActionYoutubeTypes } from '@lib/domain/order/index';
import { BrandActiveUrl } from '@lib/domain/app';
import { ParsedUrlQuery } from 'querystring';

export const parseBrandTypeToName = (brand: string): string => {
    if (brand === ActionYoutubeTypes.comment) {
        return 'Comments';
    }
    if (brand === ActionTypes.subscriber) {
        return 'Subscribers';
    }
    if (brand === ActionTypes.like) {
        return 'Likes';
    }
    if (brand === ActionTypes.follower) {
        return 'Followers';
    }
    if (brand === ActionTypes.share) {
        return 'Shares';
    }
    if (brand === ActionTypes.view) {
        return 'Views';
    }
    return 'Unknown';
};

export const parseBrandTypeToTypeYoutube = (brand: string): string => {
    if (brand === ActionYoutubeTypes.comment) {
        return 'dedicatedComments';
    }
    if (brand === ActionTypes.subscriber) {
        return 'subscribers';
    }
    if (brand === ActionTypes.like) {
        return 'likes';
    }
    if (brand === ActionTypes.follower) {
        return 'followers';
    }
    if (brand === ActionTypes.share) {
        return 'shares';
    }
    if (brand === ActionTypes.view) {
        return 'views';
    }
    if (brand === ActionTypes.watchhour) {
        return 'watchhours';
    }
    return '';
};

export const brandNameUrl = (
    pathname: string,
    query: ParsedUrlQuery,
): string => {
    const paths = pathname.split('/');
    if (
        paths[1] &&
        [
            BrandActiveUrl.tiktok,
            BrandActiveUrl.facebook,
            BrandActiveUrl.instagram,
            BrandActiveUrl.twitter,
            BrandActiveUrl.youtube,
            BrandActiveUrl.twitch,
        ].includes(paths[1] as BrandActiveUrl)
    ) {
        return paths[1];
    }
    if (
        query &&
        typeof query.from === 'string' &&
        [
            `/${BrandActiveUrl.tiktok}`,
            `/${BrandActiveUrl.facebook}`,
            `/${BrandActiveUrl.instagram}`,
            `/${BrandActiveUrl.twitter}`,
            `/${BrandActiveUrl.youtube}`,
            `/${BrandActiveUrl.twitch}`,
        ].includes(query.from)
    ) {
        return query.from?.replace('/', '') || '';
    }
    return '';
};

export const taiwindMainColor = (
    pathname: string,
    query: ParsedUrlQuery,
): string => {
    const paths = pathname && pathname.split('/');

    if (
        (paths[1] && paths[1] === BrandActiveUrl.tiktok) ||
        (query &&
            typeof query.from === 'string' &&
            query.from === `/${BrandActiveUrl.tiktok}`)
    ) {
        return 'green-tiktok';
    }
    if (
        (paths[1] && paths[1] === BrandActiveUrl.facebook) ||
        (query &&
            typeof query.from === 'string' &&
            query.from === `/${BrandActiveUrl.facebook}`)
    ) {
        return 'djsands';
    }
    if (
        (paths[1] && paths[1] === BrandActiveUrl.instagram) ||
        (query &&
            typeof query.from === 'string' &&
            query.from === `/${BrandActiveUrl.instagram}`)
    ) {
        return 'violet-instagram';
    }
    if (
        (paths[1] && paths[1] === BrandActiveUrl.twitter) ||
        (query && query.from === `/${BrandActiveUrl.twitter}`)
    ) {
        return 'violet-twitter';
    }
    if (
        (paths[1] && paths[1] === BrandActiveUrl.youtube) ||
        (query &&
            typeof query.from === 'string' &&
            query.from === `/${BrandActiveUrl.youtube}`)
    ) {
        return 'yellow-moon';
    }
    if (
        (paths[1] && paths[1] === BrandActiveUrl.twitch) ||
        (query &&
            typeof query.from === 'string' &&
            query.from === `/${BrandActiveUrl.twitch}`)
    ) {
        return 'violet-twitch';
    }
    return 'yellow-moon';
};

export const reducere = (
    price: number,
    quantity: number,
    maxQuantity: number,
    proc: number | undefined = 35,
) => {
    // var suta = 100;
    // var countC = 0;
    // var totalProc = 0;

    const lastProcent = 0;

    // if(countries && Number(setkings[current_platform].current_service.targeted)){
    // 	Object.keys(countries).forEach(function(key){
    // 		let value = countries[key];
    // 		totalProc = totalProc + parseInt(countries_proc[value].procent);
    // 		countC++;
    // 	});
    // 	lastProcent = totalProc/countC;
    // 	setTimeout(function(){
    // 		lastProcent = totalProc/countC;
    // 	},100)
    // }
    const countryPrice = (lastProcent / 100) * price;
    const procent = (quantity / maxQuantity) * proc;
    const discount = (procent / 100) * (price + countryPrice);
    const reduce = (procent / 100) * price;
    let pretRedus = price - reduce;
    const neRedus = price + pretRedus;
    const countryCharge = (lastProcent / 100) * neRedus;
    pretRedus = countryCharge + pretRedus;
    return { redus: pretRedus, discount };
};

export const youtubeParser = (url: string): string | null => {
    // eslint-disable-next-line no-useless-escape
    const regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    const match = url.match(regExp);
    return match && match[7].length === 11 ? match[7] : null;
};

export const youtubeParseChannel = (url: string): string | null => {
    const pattern =
        /^(?:(http|https):\/\/[a-zA-Z-]*\.{0,1}[a-zA-Z-]{3,}\.[a-z]{2,})\/channel\/([a-zA-Z0-9_-]{3,})$/;
    const matchs = url.match(pattern);
    if (matchs && matchs[2] && matchs[2].includes('channel') && matchs[3]) {
        return matchs[3];
    }
    return matchs && matchs[2] ? matchs[2] : null;
};
// eslint-disable-next-line
export const mapYoutubeListVideoResults = (
    data: ListVideoResultsYoutube[],
): YoutubeVideo[] => {
    const mapResults = data.map((video: ListVideoResultsYoutube) => {
        const {
            id,
            snippet: {
                title = '',
                channelId = '',
                description = '',
                channelTitle = '',
                thumbnails = {},
            },
        } = video;

        const thumbnail =
            thumbnails.high || thumbnails.medium || thumbnails.default || {};

        return {
            id: id?.videoId,
            title,
            channelId,
            description,
            channelTitle,
            url: `${APP_CONFIG.YOUTUBE.DEFAULT_URL}${id?.videoId}`,
            thumbnail: thumbnail.url || '',
        } as YoutubeVideo;
    });

    return mapResults;
};

export const mapYoutubeListChannelResults = (
    data: ListVideoResultsYoutube[],
): YoutubeVideo[] => {
    const mapResults = data.map((video: ListVideoResultsYoutube) => {
        const {
            id,
            snippet: {
                title = '',
                channelId = '',
                description = '',
                channelTitle = '',
                thumbnails = {},
            },
        } = video;

        const thumbnail =
            thumbnails.high || thumbnails.medium || thumbnails.default || {};

        return {
            id: id?.channelId,
            title,
            channelId,
            description,
            channelTitle,
            url: `${APP_CONFIG.YOUTUBE.DEFAULT_CHANNEL}${id?.channelId || channelId}`,
            thumbnail: thumbnail.url || '',
        } as YoutubeVideo;
    });

    return mapResults;
};

export function clearNumber(value = ''): string {
    return value.replace(/\D+/g, '');
}

export function validateEmail(email: string): boolean {
    const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export function formatCreditCardNumber(value: string): {
    card_no: string;
    card_type: string;
} {
    if (!value) {
        return { card_no: '', card_type: '' };
    }

    const issuer = Payment.fns.cardType(value);
    const clearValue = clearNumber(value);
    let nextValue;

    switch (issuer) {
        case 'amex':
            nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
                4,
                10,
            )} ${clearValue.slice(10, 15)}`;
            break;
        case 'dinersclub':
            nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
                4,
                10,
            )} ${clearValue.slice(10, 14)}`;
            break;
        default:
            nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
                4,
                8,
            )} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 19)}`;
            break;
    }

    return { card_no: nextValue.trim(), card_type: issuer };
}

export function formatCVC(
    value: string,
    prevValue: number,
    cardNumber: string,
): string {
    const clearValue = clearNumber(value);
    let maxLength = 4;

    if (cardNumber) {
        const issuer = Payment.fns.cardType(cardNumber);
        maxLength = issuer === 'amex' ? 4 : 3;
    }

    return clearValue.slice(0, maxLength);
}

export function formatYear(value?: string): boolean {
    if (Number(value) >= new Date().getFullYear() && value?.length === 4) {
        return true;
    }
    return false;
}

export function formatMonth(value?: string): boolean {
    if (Number(value) >= 1 && Number(value) <= 12) {
        return true;
    }
    return false;
}

export function formatExpirationDate(value: string, prevValue: string): string {
    const clearValue = clearNumber(value);
    if (clearValue.length === 1 && clearValue !== '1' && clearValue !== '0') {
        return `0${clearValue}/`;
    }
    if (clearValue.length === 2 && !/^(0?[1-9]|1[012])$/.test(clearValue)) {
        return `01/`;
    }
    if (value.length === 2 && prevValue.length === 1) {
        return `${clearValue}/`;
    }
    if (clearValue.length >= 3) {
        return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 4)}`;
    }
    return clearValue;
}

export function formatFormData(data: any): string[] {
    return Object.keys(data).map((d) => `${d}: ${data[d]}`);
}
